import React, { useState, useContext, useEffect } from 'react'
import Service from '../../../services/videos';
import GeneralService from '../../../services/general';

import List from '../../../components/videos/list';

import { ContextUI } from '../../../uiContext';
import { Context } from '../../../AppContext';
import { Button, IconButton, Paper, SearchBar, Tabs } from '../../../components/ui/core';
import { Add } from '../../../components/ui/coreIcons';

import MainMenu from '../../../components/mainmenu';
import Footer from '../../../components/mainfooter';

export default function Index(props) {
    const contextUI = useContext(ContextUI);
    const context = useContext(Context);
    const [items, setItems] = useState([]);
    const [itemsFiltered, setItemsFiltered] = useState([]);
    const [selectedTab, setSelectedTab] = useState(0);
    const [search, setSearch] = useState('');
    //INITIAL SETUP
    useEffect(() => {
        getItems();
        contextUI.setSubTitle('Videos');
        contextUI.setShowBackButton(false);
        contextUI.setHeaderActions(<IconButton onClick={addItem}><Add color="white" /></IconButton>)
        return () => { }
    }, [])

    useEffect(() => {
        setItemsFiltered(items.filter(i => { return JSON.stringify(i).toLowerCase().indexOf(search.toLowerCase()) >= 0 }));
    }, [search])

    useEffect(() => {
        setItemsFiltered(items);
        setSearch('');
    }, [items])


    //GETTING ITEMS FROM API
    const getItems = () => { Service.get().then(items => { setItems(GeneralService.sortJSON(items, 'date', '321')) }).catch(err => { console.log(err) }) }

    const addItem = () => { Service.insert({title:'Nieuwe video',date:new Date(),publish:false}).then(item => { viewItem(item._id); }).catch(ex => { console.log(ex) }) }

    const viewItem = (id) => { props.history.push('/beheer/videos/' + id) }

    if (!context.hasRights(context.user, 'fullcontrol-videos', 'w')) return null;

    return (
        <div>
            <MainMenu history={props.history} />
            <div className='contentspacing'>
              
                <Button onClick={() => { addItem() }} style={{float:'right'}}>+ Video toevoegen</Button><br style={{clear:'both'}}/> 
              
                <SearchBar value={search} onKeyUp={setSearch} onReset={() => { setSearch('') }}></SearchBar>

            <div className='padding'>
                <Paper>
                <List items={itemsFiltered} onClick={(item) => viewItem(item._id)} />
                </Paper></div>
            </div>
            <Footer />
        </div>
    )
}
